import React from 'react';
import { View, Image } from '@react-pdf/renderer';
import { styles } from '../styles';

export const ProductImage = ({ url }) => (
  <View>{url ? <Image src={url} style={styles.productImage} /> : null}</View>
);
